import env from 'env'

export function getResizedPhotoUrl(photo, width, height) {
  return env.IMAGE_URL && photo.uuid && photo.extension
    ? `${env.IMAGE_URL}/${width || ''}x${height || ''}/${photo.uuid}${photo.extension}`
    : photo.url
}
